import { atom } from "recoil"

export const teamMemberRequestState = atom<number>({
  key: "atoms/organization/team/teamMemberRequestState",
  default: 0,
})
